<div class="container px-4 px-md-3 pt-5 pb-4 py-lg-0">
  <div class="d-flex align-items-center justify-content-start">
    <h5 class="fs-20 cl-black fs-26 fw-bold mb-0">{{titleDynamic}}</h5>
    @if(isReferralInternal){
    <div class="cr-pointer ms-3 position-relative">
      <img (click)="changeStateToastShare()" src="assets/icons/share-icon.svg" class="filter-secondary" width="19px"  alt="#">
      <div class="share-toast" [ngClass]="showShareToast ? 'd-block' : 'd-none'">
        <span class="toast-arrow"></span>
        <div (click)="changeStateToastShare()" class="d-flex justify-content-end align-items-center mb-2">
          <a class="ms-1"><img class="filter-black" src="/assets/icon/x.svg" alt="x"></a>
        </div>
        <div class="d-flex justify-content-end align-items-center mb-2">
          <p class="fs-11 cl-black lh-base">Comparte este link a tu base de inversionistas, para que te sea asignada la venta. Tu inversionista tendrá acceso a la vista de este proyecto y formará parte de tus referidos.</p>
        </div>
        @for (items of shareToastItems; track $index) {
          <div class="d-flex justify-content-start align-items-center mb-2">
            @if(items.onClick) {
              <button
              class="website fw-sbold btn-link-style"
              [ngClass]="items.class"
              (click)="items.onClick()"
              >
                <img class="me-2" [src]="items.icon" [alt]="items.alt">{{ items.name }}
              </button>
            }
            @if(!items.onClick) {
              <a
              class="website fw-sbold m-auto text-center"
              [ngClass]="items.class"
              [href]="items.url"
              target="_blank"
            >
              <img class="me-2" [src]="items.icon" [alt]="items.alt">{{ items.name }}
            </a>
            }
          </div>
        }
        
      </div>
    </div>
  }
  </div>
  <p class="cl-black fs-16 mb-5 mt-4">
    <span [innerHtml]="msgDynamic | safeHtml"></span><br><br>
    <a class="video-a cr-pointer" (click)="viewVideo()"> Ver video <img src="assets/icons/video_primary.svg" alt=""> </a>
  </p>

</div>

{{ devs | json }}